import { render, staticRenderFns } from "./w-empty.vue?vue&type=template&id=aa568792&scoped=true"
import script from "./w-empty.vue?vue&type=script&lang=js"
export * from "./w-empty.vue?vue&type=script&lang=js"
import style0 from "./w-empty.vue?vue&type=style&index=0&id=aa568792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa568792",
  null
  
)

export default component.exports